import React, { useEffect, useState } from 'react';
import store, { searchActions } from '@apply/adminStore';
import { useSelector } from 'react-redux';
import { LoanTypeOptions, LoanStatusOptions } from '../../common/LoanConstants';
import { LoanSearchTable } from '../../tables/LoanSearchTable';
import debounce from 'lodash.debounce';
import { BfiCustomStore } from '../../../common/SharedComponents';
import { BorrowerModals } from '../../../borrowers/common/BorrowerComponents';
import { LoanModals } from '../../common/LoanComponents';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';

function LoansSearch({ status }) {
    const searchState = useSelector((state) => state.searchState);
    const { dispatch } = store;

    const debouncedSearch = debounce(dispatch, 500);
    const gridStore = new BfiCustomStore();

    const [loanTypeId, set_loanTypeId] = useState('');
    const [statusId, set_statusId] = useState('');

    const _onSearchChange = (event) => {
        debouncedSearch(
            searchActions.setSearchText({
                searchText: {
                    ...searchState.searchText,
                    loan: event.target.value,
                },
            })
        );
    };

    useEffect(() => {
        set_statusId(status);

        return () => {
            //Cancel any further searches if component is unloaded
            debouncedSearch.cancel();
        };
    }, [status]);

    return (
        <>
            <div
                className='main-content'
                style={{ padding: 0, backgroundColor: '#f4f4f4' }}
            >
                <div>
                    <div className='input-has-icon main-search2'>
                        <input
                            type='search'
                            placeholder='Search on BFI Number, Loan Number, City, State, Borrower or User...'
                            defaultValue={searchState?.searchText?.loan}
                            onChange={(event) => _onSearchChange(event)}
                        />
                        <FontAwesomeIcon
                            icon={faSearch}
                            aria-hidden='true'
                            className='icon'
                        />
                    </div>
                    <div
                        className='main-search2'
                        style={{ width: '200px' }}
                    >
                        <select
                            id='loanTypeId'
                            value={loanTypeId}
                            onChange={(event) => set_loanTypeId(event.target.value)}
                        >
                            {LoanTypeOptions.map((fs) => {
                                if (isNaN(parseInt(fs.id))) {
                                    return (
                                        <option
                                            key={fs.id}
                                            value={fs.id}
                                        >
                                            All Types...
                                        </option>
                                    );
                                } else {
                                    return (
                                        <option
                                            key={fs.id}
                                            value={fs.id}
                                        >
                                            {fs.name}
                                        </option>
                                    );
                                }
                            })}
                        </select>
                    </div>
                    <div
                        className='main-search2'
                        style={{ width: '250px' }}
                    >
                        <select
                            id='statusId'
                            value={statusId}
                            onChange={(event) => set_statusId(parseInt(event.target.value))}
                        >
                            {LoanStatusOptions.map((fs) => {
                                if (isNaN(parseInt(fs.id))) {
                                    return (
                                        <option
                                            key={fs.id}
                                            value={fs.id}
                                        >
                                            All Statuses...
                                        </option>
                                    );
                                } else {
                                    return (
                                        <option
                                            key={fs.id}
                                            value={fs.id}
                                        >
                                            {fs.name}
                                        </option>
                                    );
                                }
                            })}
                        </select>
                    </div>
                </div>
                <div
                    className='scrollable-content'
                    style={{ padding: '1rem' }}
                >
                    <div className='card'>
                        <div className='card-section'>
                            <LoanSearchTable
                                loanTypeId={loanTypeId}
                                statusId={statusId}
                                gridStore={gridStore}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <LoanModals />
            <BorrowerModals />
        </>
    );
}

export default LoansSearch;
